import { graphql } from "~/gql";
export const USER_SETTINGS_QUERY = graphql(/* GraphQL */ `
  query GetUserSettings {
    getUserSettings {
      darkTheme
      customPaletteHex
    }
  }
`);
